<template>

    <section class="vertical-products-wrap">

         <div class="container">
            <div class="row">
                <flash-sale
                    :title="data.flash_sale_title"
                    :url="route('storefront.flash_sale_products.index')"
                >
                </flash-sale>

            <vertical-products
                    :title="data.vertical_products_1_title"
                    :url="route('storefront.vertical_products.index', { columnNumber: 1 })"
                >
                </vertical-products>

                <vertical-products
                    :title="data.vertical_products_2_title"
                    :url="route('storefront.vertical_products.index', { columnNumber: 2 })"
                >
                </vertical-products>  
   <!--  
                 <vertical-products
                    :title="data.vertical_products_3_title"
                    :url="route('storefront.vertical_products.index', { columnNumber: 3 })"
                >
                </vertical-products>-->
            </div>

            <div align="center" style="    margin-top: 20px;padding-bottom: 50px;">
                <a class="btn btn-primary btn-deals"   href="https://ucanbe.tn/fr/categories/vente-flash/products">Découvrir nos ventes flash</a>
            </div>
        </div>

        <!--<div class="container">
            <div class="row">
                <flash-sale
                    :title="data.flash_sale_title"
                    :url="route('storefront.flash_sale_products.index')"
                >
                </flash-sale>
            </div>
        </div>

        <div class="container venteflashsecondsection" >
             <div class="row">
            <vertical-products
                    :title="data.vertical_products_1_title"
                    :url="route('storefront.vertical_products.index', { columnNumber: 1 })"
                >
                </vertical-products>

                <vertical-products
                    :title="data.vertical_products_2_title"
                    :url="route('storefront.vertical_products.index', { columnNumber: 2 })"
                >
                </vertical-products>

                <vertical-products
                    :title="data.vertical_products_3_title"
                    :url="route('storefront.vertical_products.index', { columnNumber: 3 })"
                >
                </vertical-products>
             </div>
        </div>-->
    </section>


</template>

<script>
    export default {
        props: ['data'],
    };
</script>
